import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import Employee from 'main/stores/employees/Employee';
import {BenefitClass} from 'main/stores/benefits';
import {t} from 'shared/core';
import {calendarDate} from 'shared/tools';

class EmployeeBenefitEnrollment extends DomainObject {
  employee;
  benefitClass;
  probation;
  probationTimePeriod;
  enrolmentDate;
  effectiveDate;
  companyInsuranceCarrier;
  status;
  endDate;
  reasonForUnenrolment;
  changeEffectiveDate;

  _relations = {
    employee: Employee,
    benefitClass: BenefitClass,
    probationTimePeriod: oneOf(['days', 'months']),
    _dates: ['effectiveDate', 'enrolmentDate', 'endDate', 'changeEffectiveDate']
  };

  constructor(other) {
    super();

    makeObservable(this, {
      employee: observable,
      benefitClass: observable,
      probation: observable,
      probationTimePeriod: observable,
      enrolmentDate: observable,
      effectiveDate: observable,
      companyInsuranceCarrier: observable,
      status: observable,
      endDate: observable,
      reasonForUnenrolment: observable,
      changeEffectiveDate: observable,
      translatedStatus: computed,
      effectiveDateDisplay: computed
    });

    this.merge(other);
  }

  get translatedStatus() {
    return t(`employee_benefit_enrollments.statuses.${this.status}`);
  }

  get effectiveDateDisplay() {
    return calendarDate(this.effectiveDate);
  }
}

export default EmployeeBenefitEnrollment;
